import React, { useState } from "react";
import PropTypes, { string } from "prop-types";
import styled from "styled-components";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { NumericFormat } from "react-number-format";

import OpacityIcon from "@mui/icons-material/Opacity";

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  height: 16.6rem;
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: black;
  background: white;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;

const CardTitle = styled.div`
  margin-top: 0.7rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  max-width: 8em;
`;

const CardSubTitle = styled.div`
  margin-top: 0.7rem;
  font-size: 1.3rem;
  margin-left: 0.3rem;
  font-weight: 700;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  //margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro", sans-serif;
`;

const HighchartsContainer = styled.div`
  margin-top: 0.3rem;
  //margin-right: 1rem;
`;

function PlanActionsCard(props) {
  return (
    <>
      <Card>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8} lg={8}>
            <HighchartsContainer>
              <HighchartsReact
                containerProps={{ style: { height: "16.3rem" } }}
                highcharts={Highcharts}
                options={props.options}
              />
            </HighchartsContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} lg={4}>
            <TitleContainer>
              <CardTitle>Consommation {props.cardTitle}</CardTitle>
              <CardSubTitle>
                <NumericFormat
                  value={props.cardSubTitle}
                  displayType={"text"}
                  thousandSeparator={" "}
                  decimalSeparator={","}
                  decimalScale={2}
                />{" "}
                {props.cardSubTitleUnit}
              </CardSubTitle>
            </TitleContainer>
          </GridItem>
        </GridContainer>
      </Card>
    </>
  );
}

PlanActionsCard.propTypes = {
  cardTitle: PropTypes.string,
  cardSubTitle: PropTypes.string,
  cardSubTitleUnit: PropTypes.string,
  chart: PropTypes.any,
  dataChart: PropTypes.any,
  options: PropTypes.object,
};

export default PlanActionsCard;
